export default "__VITE_ASSET__CRnMVczc__"